export default class SalesOrderActions {

    static NEW_DATA = 'NEW_DATA';
    static UPDATE_DATA='UPDATE_DATA';
    static SHOW_DATA='SHOW_DATA';
    static VIEW_DATA='VIEW_DATA';
    static DELETE_DATA='DELETE_DATA';
    static ON_SUBMIT='ON_SUBMIT';
    static ERROR_DATA='ERROR_DATA';
    static PROCESS_DATA='PROCESS_DATA';
    static RESET_DATA='RESET_DATA';
    static SUCCESS_DATA='SUCCESS_DATA';
    static GET_HELPER_SALESORDER='GET_HELPER_SALESORDER';
    static GET_HELPER_SALESORDER_FULL ='GET_HELPER_SALESORDER_FULL';
    static BEFORE_PRINT_SALESORDER ='BEFORE_PRINT_SALESORDER';
    static PRINT_SALESORDER ='PRINT_SALESORDER';
    static RESET_LIST="RESET_LIST";
  
    static submit(){
      return {
        type: SalesOrderActions.ON_SUBMIT
      };
    }
  
    static create(data) {
      return {
        type: SalesOrderActions.NEW_DATA,
        payload: data
      };
    }
  
    static update(data) {
      return {
        type: SalesOrderActions.UPDATE_DATA,
        payload: data
      };
    }
  
    static view(data) {
      return {
        type: SalesOrderActions.VIEW_DATA,
        payload: data
      };
    }
  
    static delete(data) {
      return {
        type: SalesOrderActions.DELETE_DATA
      };
    }
  
    static list(data) {
      return {
        type: SalesOrderActions.SHOW_DATA,
        payload: data
      };
    }
    static error(error){
      return {
        type: SalesOrderActions.ERROR_DATA,
        payload: error
      };
    }
    static success(){
      return {
        type: SalesOrderActions.SUCCESS_DATA,
      };
    }
    static process(){
      return {
        type: SalesOrderActions.PROCESS_DATA,
      };
    }
    static reset(){
      return {
        type: SalesOrderActions.RESET_DATA,
      };
    }
    static resetList(){
      return {
        type: SalesOrderActions.RESET_LIST,
      };
    }
  
    static helper(data){
      return {
        type: SalesOrderActions.GET_HELPER_SALESORDER_FULL,
        payload:data
      };
    }

    static helperFull(data){
      return {
        type:  SalesOrderActions.GET_HELPER_SALESORDER,
        payload:data
      };
    }
    static beforePrint(){
      return {
        type: SalesOrderActions.BEFORE_PRINT_SALESORDER,
      };
    }
    static print(data){
      return {
        type: SalesOrderActions.PRINT_SALESORDER,
        payload: data
      };
    }
  }
  
  